import type { DocEntityParentId } from "building-types/doc/docEntityConstraintTypes";
import type { PrimaryEntityId } from "building-types/doc/primaryEntityId";
import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { LineStyle, TextStyle } from "./Primitive2DOutput";
import type { SheetGeometryCategory } from "./sheetGeometryCategory";

export enum EffectType {
  VISIBILITY = "VISIBILITY",
  STYLING = "STYLING",
  SCALING = "SCALING",
  RELAXATION_OBSTACLE = "RELAXATION_OBSTACLE",
}

interface EffectBase extends DocEntityBase<"EFFECT"> {
  readonly id: PrimaryEntityId<"EFFECT">;
  readonly type: EffectType;
  /**
   * The categories to apply the override to. If empty, the effect is applied to all
   * overridable categories.
   */
  readonly categories: SheetGeometryCategory[];
  readonly parentId?: DocEntityParentId<"VIEW_TEMPLATE_OVERRIDE">;
}

export interface VisibilityEffect extends EffectBase {
  readonly type: EffectType.VISIBILITY;
  readonly invert?: boolean; // Non-inverted effect hides the selected categories. Inverted effect shows only the selected categories.
}

export interface StylingEffect extends EffectBase {
  readonly type: EffectType.STYLING;
  readonly lineStyleOverrides: LineStyle;
  readonly textStyleOverrides: TextStyle;
}

export interface ScalingEffect extends EffectBase {
  readonly type: EffectType.SCALING;
  readonly scale: number;
}

export interface RelaxationObstacleEffect extends EffectBase {
  readonly type: EffectType.RELAXATION_OBSTACLE;
  readonly targetCategory: SheetGeometryCategory | null; // Should only be null on new objects
  // readonly debugVisualization?: boolean;
  // super.categories are the obstacle categories
}

export type Effect = VisibilityEffect | StylingEffect | ScalingEffect | RelaxationObstacleEffect;
